

module.exports = __webpack_require__.stylable.create(
    "SectionNotificationButton1108563059",
    {"classes":{"root":"SectionNotificationButton1108563059__root","button":"SectionNotificationButton1108563059__button"},"vars":{},"stVars":{"FontSize":"14px","TextButtonColor":"#000000","BasicButtonTextColor":"#FFFFFF","BasicButtonBackgroundColor":"#000000","BasicButtonBorderColor":"#000000","SecondaryButtonTextColor":"#000000","SecondaryButtonBorderColor":"#000000"},"keyframes":{}},
    "",
    1,
    "SectionNotificationButton1108563059",
    null
);
